import React, { useRef } from 'react';
import useTrapFocus from './useTrapFocus';
const ModalContentPure = ({ beforeElementRef, trapFocusRef, afterElementRef, testId = 'store-modal-content', children, ...otherProps }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: beforeElementRef, "data-testid": "beforeElement", tabIndex: 0, "aria-hidden": "true" }),
        React.createElement("div", Object.assign({ "data-store-modal-content": true, "data-testid": testId, ref: trapFocusRef, "aria-modal": "true", role: "dialog", tabIndex: -1 }, otherProps), children),
        React.createElement("div", { ref: afterElementRef, "data-testid": "afterElement", tabIndex: 0, "aria-hidden": "true" })));
};
const ModalContent = ({ children, ...otherProps }) => {
    const trapFocusRef = useRef(null);
    const beforeElementRef = useRef(null);
    const afterElementRef = useRef(null);
    useTrapFocus({
        beforeElementRef,
        trapFocusRef,
        afterElementRef,
    });
    return (React.createElement(ModalContentPure, Object.assign({}, otherProps, { trapFocusRef: trapFocusRef, beforeElementRef: beforeElementRef, afterElementRef: afterElementRef, onClick: (event) => {
            event.stopPropagation();
        } }), children));
};
export default ModalContent;
//# sourceMappingURL=ModalContent.js.map